import { ReactElement, useEffect, useState } from "react";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "../../components/ui/popover";
import { Button } from "../../components/ui/button";
import {
	Command,
	CommandEmpty,
	CommandInput,
	CommandItem,
	CommandList,
} from "../../components/ui/command";
import { Checkbox } from "../../components/ui/checkbox";
import { ChevronDown } from "lucide-react";
import Alteracoes from "../../assets/kinologyIcons/svg/alteracoes.svg";

interface TypesMultiselect {
	title: string;
	IconLucide?: any;
	Searchable?: boolean;
	data: any;
	onSelectChange?: (selected: string[]) => void;
	CurrentSelected: any;
	customIcon?: any;
	customPanel?:boolean;
	clearFilter?: boolean
}

const MultiSelect: React.FC<TypesMultiselect> = ({
	title,
	IconLucide,
	Searchable,
	data,
	onSelectChange,
	CurrentSelected,
	customIcon,
	customPanel = false,
	clearFilter,
}) => {
	const [open, setOpen] = useState(false);
	const [selected, setSelected] = useState<string[]>([]);

	useEffect(() => {
		if (CurrentSelected) {
			setSelected(CurrentSelected)
		}
	}, []);

	useEffect(()=>{
		if(clearFilter){
			setSelected([])
		}
	},[clearFilter])


	const toggleOption = (value: string) => {
		setSelected((prev) => {
			const newSelected = prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value];
			if (onSelectChange) {
				onSelectChange(newSelected); // Chamando a função de callback
			}
			return newSelected;
		});
	};




	return (
		<Popover open={open} onOpenChange={setOpen} modal={true}>
			<PopoverTrigger asChild className="w-[180px] rounded-[30px]">
				<Button
					variant="outline"
					role="combobox"
					style={{ fontWeight: 400 }}
					className={ customPanel 
						? "w-[auto]  flex items-start justify-between gap-2 border 	border-[#ABADB7]"
						: "w-[200px]  flex items-start justify-between gap-2 	border 	border-[#ABADB7]"
					}
				>
					<div style={{ display: 'flex', flexDirection: 'row', gap: 5, color: selected?.length > 0 ? '#000E4B' : '#000E4B60' ,   }}>
						{IconLucide != "Alteracoes" && !customIcon ?
							<IconLucide className="w-4 h-4" color="#000E4B" />
							:	!customIcon
								?	<img className="w-4 h-4" src={Alteracoes} alt="" />
								: <img className="w-4 h-4" src={customIcon} alt="" />
						}
						{selected.length > 0 ? `${selected.length} selecionado(s)` : title}
					</div>
					<ChevronDown className="w-3 h-3" color="#000E4B" />
				</Button>

			</PopoverTrigger>

			<PopoverContent className="w-[200px] p-0 bg-white pointer-events-auto">

				<Command style={{ pointerEvents: 'all' }}>
					{Searchable &&
						<>

							<CommandInput placeholder="Pesquisar" />

						</>
					}
					<CommandList>

						<CommandEmpty>No results found.</CommandEmpty>

						{data.map((option: any) => (
							<CommandItem
								style={{ color: "#3D4259", cursor: 'pointer',  }}
								key={option.value}
								onSelect={() => toggleOption(option.value)}
							>
								<Checkbox
									style={{ color: "#3D4259" }}
									checked={selected.includes(option.value)}
									onCheckedChange={()=> {toggleOption(option.value)}}
									onClick={(e) => e.stopPropagation()}
									className="mr-2"
								/>
								{title == "Alterações" &&
									<div style={{ width: 15, height: 15, backgroundColor: option.color, borderRadius: '50%' }}></div>
								}
								{option.label}
							</CommandItem>
						))}
					</CommandList>
				</Command>
			</PopoverContent>
		</Popover>
	);
};

export default MultiSelect;
